export const websiteContent = {
  en: {
    title: "Website Content",
    subtitle: "Edit text content for solariis.com homepage sections",
    spanish: "Español",
    english: "English",
    unsavedChanges: "Unsaved changes",
    refreshContent: "Refresh content",
    howItWorks: "How it works:",
    editContent: "Edit content for each section and click Save",
    changesImmediate: "Changes are immediately visible on the live website",
    switchLanguages: "Switch between languages using the tabs above",
    eachLanguage: "Each language has its own set of content",
    unsavedChangesTitle: "Unsaved Changes",
    unsavedChangesDesc: "Switching languages will discard these changes.",
    unsavedChangesSections: "section(s).",
    unsavedChangesQuestion: "Do you want to continue?",
    stayAndSave: "Stay & Save Changes",
    discardAndSwitch: "Discard & Switch",
    loadingWebsiteContent: "Loading website content",
    errorLoadContent: "Failed to load website content. Please try again.",
    unsavedChangesInSections: "You have unsaved changes in",
    savedSuccessfully: "saved successfully",
    failedToSave: "Failed to save. Please try again.",
    // Video uploader
    video: "Video",
    uploadingVideo: "Uploading video...",
    videoFormat: "MP4 video or GIF (max 50MB)",
    hoverToPreview: "Hover to preview",
    dropVideoFile: "Please drop an MP4 video or GIF file",
    // Image uploader
    image: "Image",
    imageFormat: "PNG, JPG, WebP, GIF (max 10MB)",
    dropImageFile: "Please drop an image file",
  },
  es: {
    title: "Contenido Web",
    subtitle: "Edita el contenido de texto de las secciones de la página principal de solariis.com",
    spanish: "Español",
    english: "Inglés",
    unsavedChanges: "Cambios sin guardar",
    refreshContent: "Actualizar contenido",
    howItWorks: "Cómo funciona:",
    editContent: "Edita el contenido de cada sección y haz clic en Guardar",
    changesImmediate: "Los cambios son visibles inmediatamente en el sitio web",
    switchLanguages: "Cambia entre idiomas usando las pestañas de arriba",
    eachLanguage: "Cada idioma tiene su propio conjunto de contenido",
    unsavedChangesTitle: "Cambios sin Guardar",
    unsavedChangesDesc: "Cambiar de idioma descartará estos cambios.",
    unsavedChangesSections: "sección(es).",
    unsavedChangesQuestion: "¿Deseas continuar?",
    stayAndSave: "Quedarse y Guardar",
    discardAndSwitch: "Descartar y Cambiar",
    loadingWebsiteContent: "Cargando contenido web",
    errorLoadContent: "Error al cargar el contenido web. Inténtalo de nuevo.",
    unsavedChangesInSections: "Tienes cambios sin guardar en",
    savedSuccessfully: "guardado exitosamente",
    failedToSave: "Error al guardar. Inténtalo de nuevo.",
    // Video uploader
    video: "Video",
    uploadingVideo: "Subiendo video...",
    videoFormat: "Video MP4 o GIF (máx 50MB)",
    hoverToPreview: "Pasa el mouse para vista previa",
    dropVideoFile: "Por favor suelta un archivo de video MP4 o GIF",
    // Image uploader
    image: "Imagen",
    imageFormat: "PNG, JPG, WebP, GIF (máx 10MB)",
    dropImageFile: "Por favor suelta un archivo de imagen",
  },
};
